import './style.scss';

export const Landing = () => {
  return <div className="landing-page-container"></div>;
};
